import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import GroupIcon from "@mui/icons-material/Group";
import SearchIcon from "@mui/icons-material/Search";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import { useAuth } from "../../context/AuthContext";

const drawerWidth = 240;

const Sidebar = ({ open, toggleDrawer }) => {
  const location = useLocation();
  const { user } = useAuth();
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const isAdmin = user && user.role === "admin";

  const mainMenuItems = [
    {
      text: "Dashboard",
      icon: <DashboardIcon />,
      path: "/",
    },
    {
      text: "Prospects",
      icon: <PeopleIcon />,
      path: "/prospects",
    },
    {
      text: "Boards",
      icon: <ViewKanbanIcon />,
      path: "/boards",
    },
    {
      text: "Advanced Search",
      icon: <SearchIcon />,
      path: "/advanced-search",
    },
    {
      text: "Depth Chart",
      icon: <SportsSoccerIcon />,
      path: "/depth-chart",
    },
    {
      text: "Coach Database",
      icon: <GroupIcon />,
      path: "/coaches",
    },
  ];

  const adminMenuItems = [];

  const MenuList = () => (
    <Box sx={{ overflow: "auto", paddingTop: "64px" }}>
      <List>
        {mainMenuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={RouterLink}
              to={item.path}
              selected={location.pathname === item.path}
              onClick={() => {
                if (!isMdUp) toggleDrawer();
              }}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {isAdmin && (
        <>
          <Divider />
          <List>
            {adminMenuItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  component={RouterLink}
                  to={item.path}
                  selected={location.pathname === item.path}
                  onClick={() => {
                    if (!isMdUp) toggleDrawer();
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  );

  return (
    <>
      {/* Mobile/Tablet: Temporary Drawer */}
      <Drawer
        variant="temporary"
        open={open && !isMdUp}
        onClose={toggleDrawer}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
          },
        }}
      >
        <MenuList />
      </Drawer>

      {/* Desktop: Permanent Drawer */}
      <Drawer
        variant="permanent"
        open={isMdUp}
        sx={{
          display: { xs: "none", md: "block" },
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            ...(open ? {} : { transform: "translateX(-100%)" }),
            transition: "transform 0.3s ease-in-out",
          },
        }}
      >
        <MenuList />
      </Drawer>
    </>
  );
};

export default Sidebar;
